export default "<p>careers works!</p>\n";